import React from 'react';
type Variant = 'solid' | 'dashed' | 'dotted';

interface Props {
  variant?: Variant;
  className?: string;
}

const Divider: React.FC<Props> = ({ variant = 'solid', className = '' }) => (
  <hr className={`pdq-divider ${variant} ${className}`} />
);

export default Divider;
